"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _ChatsLoader = require("./ChatsLoader");
Object.keys(_ChatsLoader).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ChatsLoader[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ChatsLoader[key];
    }
  });
});
var _CultureProvider = require("./CultureProvider");
Object.keys(_CultureProvider).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _CultureProvider[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _CultureProvider[key];
    }
  });
});
var _Footer = require("./Footer");
Object.keys(_Footer).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Footer[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Footer[key];
    }
  });
});
var _Head = require("./Head");
Object.keys(_Head).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Head[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Head[key];
    }
  });
});
var _LanguageSwitcher = require("./LanguageSwitcher");
Object.keys(_LanguageSwitcher).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _LanguageSwitcher[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _LanguageSwitcher[key];
    }
  });
});
var _LoginProvider = require("./LoginProvider");
Object.keys(_LoginProvider).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _LoginProvider[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _LoginProvider[key];
    }
  });
});
var _Page = require("./Page");
Object.keys(_Page).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Page[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Page[key];
    }
  });
});
var _PageBackgroundColor = require("./PageBackgroundColor");
Object.keys(_PageBackgroundColor).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _PageBackgroundColor[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _PageBackgroundColor[key];
    }
  });
});
var _TopArea = require("./TopArea");
Object.keys(_TopArea).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TopArea[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _TopArea[key];
    }
  });
});
